import { TemplateProfile } from "../../../../../core/entities/templateProfile";
import React from "react";
import { TemplateList } from "./TemplateList";
import { Template } from "../../../../../core/entities/template";

export function VersionHistory({
    profile,
    onSelect,
    onEdit,
    selected
}: {
    profile: TemplateProfile;
    selected: Template;
    onSelect: (template: Template) => void;
    onEdit: (template: Template) => void;
}) {
    const history = profile.published
        ? [profile.published, ...profile.history]
        : profile.history;
    const drafts = profile.draft ? [profile.draft] : [];

    const draftComponent = (
        <TemplateList
            selected={selected}
            expandable={false}
            onSelect={onSelect}
            onEdit={onEdit}
            header={"Kladde"}
            templates={drafts}
        />
    );
    const historyComponent = (
        <TemplateList
            selected={selected}
            expandable={true}
            onSelect={onSelect}
            onEdit={onEdit}
            showUpTo={3}
            header={"Publiceret"}
            templates={history}
        />
    );
    return (
        <div className={"space-y-4"}>
            {historyComponent}
            {draftComponent}
        </div>
    );
}
